import { render } from "./ProductHotListShow.vue?vue&type=template&id=e9bbc1ac&scoped=true"
import script from "./ProductHotListShow.vue?vue&type=script&lang=js"
export * from "./ProductHotListShow.vue?vue&type=script&lang=js"

import "./ProductHotListShow.vue?vue&type=style&index=0&id=e9bbc1ac&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9bbc1ac"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/ProductHotListShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e9bbc1ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e9bbc1ac', __exports__)) {
    api.reload('e9bbc1ac', __exports__)
  }
  
  module.hot.accept("./ProductHotListShow.vue?vue&type=template&id=e9bbc1ac&scoped=true", () => {
    api.rerender('e9bbc1ac', render)
  })

}


export default __exports__